
<script setup>
    const props = defineProps({
        loadingState: Object
    });
</script>

<template>
    <div class="size-full grid place-content-center">
        <div>
            <svg class="animate-spin mx-auto text-secondary size-10 mb-5" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56C43.464 56 56 43.464 56 28H54C54 42.3594 42.3594 54 28 54C13.6406 54 2 42.3594 2 28C2 13.6406 13.6406 2 28 2V0Z" fill="currentColor"/>
            </svg>

            <div class="bg-secondary/20 relative w-80 h-0.5 mb-4">
                <div
                    :style="{transform: `scaleX(${props.loadingState.progress})`}"
                    class="absolute left-0 top-0 size-full bg-secondary origin-left transition-transform"
                >
                </div>
            </div>

            <p class="r-text-16 text-center" v-text="props.loadingState.message"></p>
        </div>
    </div>
</template>
